import FormTrackingIdMapping from './FormTrackingIdMapping';
import GMFormTrackingIdMapping from './GMFormTrackingIdMapping';
import NissanFormTrackingIdMapping from './NissanFormTrackingIdMapping';

export default {
	FormTrackingIdMapping,
	GMFormTrackingIdMapping,
	NissanFormTrackingIdMapping
};
